import { jsx as _jsx } from "react/jsx-runtime";
import { StyledGrid } from './styles';
export function Grid({ children, as = 'div', gap = { small: '16px', large: '32px' }, ...rest }) {
    const getGap = typeof gap === 'object' ? { ...gap } : { small: gap };
    return (
    // @ts-ignore
    _jsx(StyledGrid, { as: as, gap: { ...getGap }, ...rest, children: children }));
}
//# sourceMappingURL=index.js.map